import { g as getTime } from './CO6_I4B4.mjs';

function requestAnimFrame(callback, ...args) {
  const w = window;
  return (w.requestAnimationFrame || w.webkitRequestAnimationFrame || w.mozRequestAnimationFrame || ((cb) => window.setTimeout(cb, 1e3 / 60))).apply(null, [callback, ...args]);
}
function getNewScrollPosition(from, to, currentState, easingFnc) {
  return from - (from - to) * easingFnc(currentState);
}
function scrollToInternal(scrollBase, scrollFrom, scrollTo, startTime, duration, easingFnc) {
  const base = scrollBase;
  const current = getTime();
  const start = startTime === 0 ? current - 1 : startTime;
  const currentState = (current - start) / duration;
  if (currentState > 1) {
    base.scrollTop = scrollTo;
    return;
  }
  base.scrollTop = getNewScrollPosition(scrollFrom, scrollTo, currentState, easingFnc);
  requestAnimFrame(() => {
    scrollToInternal(scrollBase, scrollFrom, scrollTo, start, duration, easingFnc);
  });
}

export { getNewScrollPosition as g, requestAnimFrame as r, scrollToInternal as s };
/*                                 */
